export default ({request}) =>({
    masCategoryTreeApi(data = {}){
        return request({
            url: '/master/masterCategory/selectTree',
            method:'post',
            data,
        })
    },
    masCategoryListApi(data = {}){
        return request({
            url: '/master/masterCategory/list',
            method:'post',
            data,
        })
    },
    masCategorySaveApi(data = {}){
        return request({
            url: '/master/masterCategory/save',
            method:'post',
            data,
        })
    },
    masCategoryDetailApi(data = {}){
        return request({
            url: '/master/masterCategory/detail',
            method:'post',
            data,
        })
    },
    masCategoryDelApi(data = {}) {
        return request({
          url: '/master/masterCategory/del',
          method: 'post',
          data,
        })
    },
})